var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_c('Topo',{attrs:{"logado":""}}),_c('MenuLateral'),_c('InternaMain',{staticClass:"pb-0",attrs:{"maxwidth-container":"700px"}},[_c('CartoesStepper')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }